import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { userSlice } from "../redux/user/userSlice";
import { getLinks } from "../redux/asyncThunk/userActions";

const { selectProject, showDialog, resetSelectedProject, closeDialog } =
  userSlice;

export default function SideMenu() {
  const dispatch = useDispatch();
  const [links, setLinks] = useState([]);
  const games = useSelector((state) => state.user?.gamesLinks);
  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const user = useSelector((state) => state.user?.data?.user);

  useEffect(() => {
    if (user?.id) {
      dispatch(getLinks({ userId: user.id }));
    }
  }, [dispatch, user?.id]);

  useEffect(() => {
    if (games) {
      setLinks(games);
    }
  }, [games]);

  const handleActive = (id) => {
    dispatch(selectProject(id));
  };

  return (
    <aside className="app-sidebar">
      <div className="app-sidebar__top">
        <Button
          variant="contained"
          size="small"
          className="app-btn app-btn--primary"
          onClick={() => dispatch(showDialog("new"))}
        >
          Создать сценарий
        </Button>

        <Link to="/main" style={{ textDecoration: "none" }}>
          <Button
            variant="outlined"
            size="small"
            className="app-btn app-btn--secondary"
            onClick={() => dispatch(resetSelectedProject())}
          >
            Рабочий стол
          </Button>
        </Link>

        <div className="app-sidebar__section-title">Ваши сценарии</div>

        {!links?.length ? (
          <div className="app-sidebar__empty">Пока нет созданных сценариев</div>
        ) : (
          <ul className="app-sidebar__list">
            {links.map((el) => (
              <li key={el._id}>
                <Link
                  to={`/main/${el._id}`}
                  state={{ projectId: el._id, type: "edit" }}
                  className={`app-sidebar__link${
                    selectedGameId === el._id ? " app-sidebar__link--active" : ""
                  }`}
                  onClick={() => {
                    handleActive(el._id);
                    dispatch(closeDialog());
                  }}
                >
                  {el.title}
                </Link>
              </li>
            ))}
          </ul>
        )}

        <div className="app-sidebar__divider" />
      </div>

      <div className="app-sidebar__footer">
        <Link
          to="/main/rules"
          onClick={() => dispatch(resetSelectedProject())}
          style={{ textDecoration: "none" }}
        >
          <Button variant="contained" size="small" className="app-btn app-btn--ghost">
            Правила
          </Button>
        </Link>
      </div>
    </aside>
  );
}
